<template>
    <div
        class="property-card h-60 gap-3 flex flex-col"
        :class="{ 'w-full pr-3': widgetView, 'w-full': cardType === 'map' }"
        ref="elementRef"
    >
        <div class="relative overflow-hidden w-full h-44">
            <router-link
                :to="'/hotels/properties/' + property.slug"
                @click="handleClick()"
            >
                <ImageLoader>
                    <template #image>
                        <img
                            :src="property.image_location"
                            :alt="'Photo of ' + property.name"
                            class="rounded-lg w-full h-44 object-cover"
                        />
                    </template>
                    <template #error>
                        <div
                            class="w-full h-44 rounded-lg object-cover flex items-center justify-center text-center flex-col bg-slate-200 text-slate-400"
                        >
                            <Icon icon="no-image" />
                        </div>
                    </template>
                </ImageLoader>
            </router-link>
            <!-- START FAV BUTTON -->
            <div
                class="absolute w-8 h-8 mr-2 mt-2 z-50"
                :class="{
                    'right-1 top-1': cardType !== 'map',
                    'right-12 top-2': cardType === 'map',
                }"
            >
                <Fav
                    :property="property"
                    :isWidget="widgetView"
                    :indie="widgetView"
                    @remove-fav="handleRemoveFav"
                />
            </div>
            <!-- START BRAND IMAGE -->
            <div
                class="h-9 p-2 bg-white/90 rounded justify-center items-center inline-flex absolute bottom-2 right-2"
            >
                <img
                    :src="property.program.image"
                    class="max-w-[68px] h-auto max-h-7"
                />
            </div>
            <!-- END BRAND IMAGE -->
        </div>
        <!-- START PROPERTY NAME -->
        <div
            class="text-slate-800 text-sm font-medium leading-tight relative h-8"
        >
            <router-link :to="'/hotels/properties/' + property.slug">
                <div
                    class="flex-col justify-start items-start gap-1 flex text-left"
                >
                    <div
                        class="text-slate-800 font-medium text-ellipsis w-full whitespace-nowrap overflow-hidden"
                        :class="{
                            'text-xl': cardType === 'map',
                            'text-sm': cardType !== 'map',
                        }"
                        v-text="property.name"
                    ></div>
                    <div
                        class="text-slate-500 text-sm font-normal w-full whitespace-nowrap overflow-hidden text-ellipsis"
                    >
                        {{ computedAddress }}
                    </div>
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
import { computed, ref } from 'vue';
import { useHotelsStore } from '@/store/hotels';
import Fav from '@/components/hotels/property/fav.vue';
import ImageLoader from '@/components/ui/image-loader/image-loader.vue';
import Icon from '@/components/ui/icon/icon.vue';

export default {
    name: 'PropertyCardSmall',
    props: { property: Object, widgetView: Boolean, cardType: String },
    components: { Fav, ImageLoader, Icon },
    setup(props) {
        const hotelsStore = useHotelsStore();
        const elementRef = ref(null);
        const fullAddress = () => {
            const {
                address_1,
                address_2,
                locality,
                region,
                postal_code,
                country,
            } = props.property;
            return [
                address_1,
                address_2,
                locality,
                region,
                postal_code,
                country,
            ]
                .filter((part) => part)
                .join(', ');
        };

        const computedAddress = computed(() => {
            if (props.cardType !== 'map') {
                return `${props.property.locality}, ${props.property.country}`;
            } else {
                return fullAddress();
            }
        });

        const handleClick = () => {
            if (props.cardType === 'map') {
                hotelsStore.setShowOnMap(false);
            }
        };

        const handleRemoveFav = () => {
            if (elementRef.value) {
                elementRef.value.style.transition =
                    'opacity 0.5s ease, transform 0.5s ease';
                elementRef.value.style.opacity = '0';
                elementRef.value.style.transform = 'translateX(-100px)';
            }
        };

        return {
            fullAddress,
            computedAddress,
            elementRef,
            handleClick,
            handleRemoveFav,
        };
    },
};
</script>

<style lang="scss" scoped>
.property-card {
    position: relative;
}

.property-card::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.2);
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
}

.property-card:hover::after {
    opacity: 1;
}
</style>
